module.exports = __webpack_public_path__ + "img/1557614097595441154.3b98ecb6.png";